<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#pablo">Fowlers Admin</a>
    </div>

    <template slot="navbar-menu">
      <ul class="navbar-nav">
<!--        <li class="nav-item">-->
<!--          <a class="nav-link btn-rotate" href="#pablo">-->
<!--            <i class="nc-icon nc-settings-gear-65"></i>-->
<!--          </a>-->
<!--        </li>-->
        <drop-down icon="nc-icon nc-settings-gear-65" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item btn-rotate dropdown">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <a class="dropdown-item" href="/admin/roles">Roles</a>
          <a class="dropdown-item" href="/admin/syncs">Syncs</a>
          <a class="dropdown-item" href="/admin/scrapes">Scrapes</a>
          <a class="dropdown-item" href="/admin/audit-log">Audit Log</a>
          <a class="dropdown-item" href="/admin/import">Import</a>
          <a><hr></a>
          <a class="dropdown-item" href="/admin/roles" target="_blank">Back to store</a>
          <a class="dropdown-item" @click="logout()">Logout</a>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
  import { EventBus } from '@/event-bus.js';

  export default {
    components: {
      Navbar,
      NavbarToggleButton
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },

      logout(){
        EventBus.$emit("toggleDashboardLoader", "show");
        const vm = this
        console.log('logout')
        this.$store.dispatch('auth/logout', {})
        .then((response) => {
          vm.$router.push({ path: 'login', query: {msg: 1} })
        }).catch((error)=>{
          console.log('error', error);
        });
      }
    }
  }

</script>
<style>

</style>
